import styled from 'styled-components';
import {StripOverlay} from './LightHomePage.style';
import {media} from '../../styles/components/media-queries';

export const Wrapper = styled.section`
  background: ${p => `url(${p.backgroundImages.desktop}) no-repeat center center fixed`};
  background-size: cover;
  width: 100%;
  color: ${p => p.theme.primaryColor};
  ${media.small`
    background-attachment: initial;
  `}
`;

export const Block = styled.div`
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
  padding: 0 2rem;
  text-align: left;
  letter-spacing: 0.1rem;
  h4 {
    font-size: 2rem;
    font-weight: normal;
    letter-spacing: 0.1rem;
    margin: 2rem 0;
  }

  ${media.small`
    padding: 2rem;
    flex-basis: auto;
  `};
`;

export const StripOverlayRow = StripOverlay.extend`
  flex-direction: row;
  align-items: flex-start;
  ${media.small`
    flex-direction: column;
  `};
`;

export const Title = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 2rem;
  font-weight: 400;
  line-height: 2.8rem;
  margin: 2rem 0;
  ${media.small`
    margin: 1rem 0;
  `};
`;

export const SubTitle = styled.span`
  display: block;
  text-decoration: underline;
  font-size: 1.6rem;
  line-height: 2rem;
  cursor: pointer;
  padding: 2rem 0;
`;

export const Text = styled.div`
  font-size: 1.8rem;
  font-weight: 300;
  line-height: 3.4rem;
  white-space: pre-line;
  ${media.small`
    font-size: 1.6rem;
    line-height: 2.8rem;
  `};
`;

export const Phone = Text.extend`
  margin: 2.2rem 0;
`;

export const SocialMedia = styled.div`
  display: flex;
`;

export const Icon = styled.a`
  outline: none;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4.4rem;
  height: 4.4rem;
  cursor: pointer;
  border-radius: 50%;
  background-color: ${p => p.theme.primaryColor};
  opacity: 0.7;
  margin-right: 1rem;
  &:hover {
    opacity: 1;
  }
`;

export const Fb = styled.img`
  width: 1.3rem;
`;

export const Twitter = styled.img`
  width: 2rem;
`;

export const Tripadvisor = styled.img`
  width: 2.6rem;
`;

export const Instagram = styled.img`
  width: 2rem;
`;

export const MapsLink = styled.a`
  color: ${p => p.theme.primaryColor};
  font-size: 1.2rem;
`;



// WEBPACK FOOTER //
// ./containers/LightHomePage/OpeningTimes.style.js